import React from 'react';
import {
  Image,
  Stack,
  VStack,
  Container,
  Flex,
  useBreakpointValue,
  Heading,
} from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout';
import TextWithRightMedia from '../../components/sections/textwithrightmedia';
import TextWithLeftMedia from '../../components/sections/textwithleftmedia';

import InclusionDiversityHero from '../../components/ui/ourcompany/S18-Montrail-TK-1187-copy-crop1651x903.png'
import InclusionDiversitySelfie from '../../components/ui/ourcompany/S19_CAS_BR_OR_0068-copy.jpeg'
import GertImg from '../../components/ui/ourcompany/gert_boyle.jpeg'

export default function StrategyMissionValues() {
  return (
    <HomeLayout align="left">
      <title>Diversity, Equity, & Inclusion</title>
      <meta name="description" content="We connect active people with their passions across race, ethnicity, gender, ability, religion and sexual orientation." />
      <Stack w="full" className='page-banner'></Stack>
      <Flex
        w={'full'}
        h={'60vh'}
        backgroundImage={`url(${InclusionDiversityHero})`}
        backgroundSize={'cover'}
        backgroundPosition={'center center'}
        id="strategyMissionValuesHeroImg"
      >
        <VStack
          w={'full'}
          justify={'flex-end'}
          align={'left'}
          pb={useBreakpointValue({ base: 4, md: 12 })}
          bgGradient='to-r'
          gradientFrom={'blackAlpha.600'}
          gradientTo={'transparent'}
        >
          <Container maxW={'6xl'}>
            <Heading
              as={'h1'}
              color={'white'}>
              The Outdoors is for Everyone
            </Heading>
          </Container>
        </VStack>
      </Flex>
      <Container maxW={'6xl'}>
      <TextWithRightMedia
        title={<h2>Inclusion, Diversity & Equity</h2>}
        content={<p>
            The outdoors is diverse. In nature, different colors, shapes and
            species thrive due to their diversity. Diverse perspectives lead to
            creativity and innovation. Equity leads to empowerment. Inclusion
            leads to teamwork. We've grown from a family business to a global
            company because we understand what it takes to flourish. Since 1938,
            we have been making clothing and footwear so that more people can
            enjoy the outdoors. We connect active people with their passions
            across race, ethnicity, gender, ability, religion and sexual
            orientation. Doing the right thing for our consumers, customers,
            employees, the company and our communities is one of our core
            values. We are dedicated to creating a company that is diverse,
            equitable and inclusive because one thing that we can all agree on
            is the outdoors is for all of us.
            </p>
        }
        media={<Image src={InclusionDiversitySelfie} />}
      />
      <TextWithLeftMedia
        title={<h2>Our History Informs Our Present</h2>}
        content={
          <p>
            Columbia Sportswear Company was founded by immigrants fleeing Nazi
            Germany. Their daughter, Gert Boyle, held every position, from
            seamstress of the first fishing vest to President and Chair of the
            Board. Ma Boyle was a pioneer as a woman in the outdoor industry.
            Her legacy continues to inspire us now that we are a global company
            with more than 7,000 employees all over the world.
          </p>
        }
        media={<Image src={GertImg} />}
      />
      </Container>
    </HomeLayout>
  );
}
